import axios from 'axios';
import { retrieveAccessToken } from '../../../../shared/infra/auth/RetrieveAccessToken.jsx';

const deleteMedia = async (draftId, mediaId) => {
  try {
    const accessToken = await retrieveAccessToken();
    const response = await axios.delete(`/api/editor/draft/${draftId}/media/${mediaId}`, {
      headers: {
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {})
      }
    });
    console.log('Media deleted successfully:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error deleting media:', error);
    throw error;
  }
};

export { deleteMedia };